'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.takeEveryAndCancel = takeEveryAndCancel;
exports.takeLatestAndCancel = takeLatestAndCancel;
exports.takeLatestAndCancelGroupBy = takeLatestAndCancelGroupBy;

var _effects = require('redux-saga/effects');

var _utils = require('./utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _marked =
/*#__PURE__*/
_regenerator2.default.mark(takeEveryAndCancel),
    _marked2 =
/*#__PURE__*/
_regenerator2.default.mark(takeLatestAndCancel),
    _marked3 =
/*#__PURE__*/
_regenerator2.default.mark(takeLatestAndCancelGroupBy);

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function takeEveryAndCancel(pattern, cancelPattern, saga) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var task;
  return _regenerator2.default.wrap(function takeEveryAndCancel$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.fork)(
          /*#__PURE__*/
          _regenerator2.default.mark(function _callee() {
            var pendingTasks, action, i, _task, _task2;

            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    pendingTasks = [];

                  case 1:
                    if (!true) {
                      _context.next = 24;
                      break;
                    }

                    _context.next = 4;
                    return (0, _effects.take)((0, _utils.mergeActionPatterns)(pattern, cancelPattern));

                  case 4:
                    action = _context.sent;

                    if (!(0, _utils.matchActionPattern)(action, cancelPattern)) {
                      _context.next = 17;
                      break;
                    }

                    i = 0;

                  case 7:
                    if (!(i < pendingTasks.length)) {
                      _context.next = 14;
                      break;
                    }

                    _task = pendingTasks[i];
                    _context.next = 11;
                    return (0, _effects.cancel)(_task);

                  case 11:
                    i++;
                    _context.next = 7;
                    break;

                  case 14:
                    pendingTasks = [];
                    _context.next = 22;
                    break;

                  case 17:
                    _context.next = 19;
                    return _effects.fork.apply(undefined, [saga].concat(_toConsumableArray(args.concat(action))));

                  case 19:
                    _task2 = _context.sent;
                    pendingTasks.push(_task2);
                    pendingTasks = pendingTasks.filter(function (task) {
                      return !task.isRunning();
                    });

                  case 22:
                    _context.next = 1;
                    break;

                  case 24:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

        case 2:
          task = _context2.sent;
          return _context2.abrupt('return', task);

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked, this);
}

function takeLatestAndCancel(pattern, cancelPattern, saga) {
  for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    args[_key2 - 3] = arguments[_key2];
  }

  var task;
  return _regenerator2.default.wrap(function takeLatestAndCancel$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.fork)(
          /*#__PURE__*/
          _regenerator2.default.mark(function _callee2() {
            var lastTask, action;
            return _regenerator2.default.wrap(function _callee2$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    lastTask = void 0;

                  case 1:
                    if (!true) {
                      _context3.next = 14;
                      break;
                    }

                    _context3.next = 4;
                    return (0, _effects.take)((0, _utils.mergeActionPatterns)(pattern, cancelPattern));

                  case 4:
                    action = _context3.sent;

                    if (!lastTask) {
                      _context3.next = 8;
                      break;
                    }

                    _context3.next = 8;
                    return (0, _effects.cancel)(lastTask);

                  case 8:
                    if ((0, _utils.matchActionPattern)(action, cancelPattern)) {
                      _context3.next = 12;
                      break;
                    }

                    _context3.next = 11;
                    return _effects.fork.apply(undefined, [saga].concat(_toConsumableArray(args.concat(action))));

                  case 11:
                    lastTask = _context3.sent;

                  case 12:
                    _context3.next = 1;
                    break;

                  case 14:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee2, this);
          }));

        case 2:
          task = _context4.sent;
          return _context4.abrupt('return', task);

        case 4:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked2, this);
} // Difficult: Perfect Master


function takeLatestAndCancelGroupBy(pattern, cancelPattern, saga, groupBy) {
  for (var _len3 = arguments.length, args = Array(_len3 > 4 ? _len3 - 4 : 0), _key3 = 4; _key3 < _len3; _key3++) {
    args[_key3 - 4] = arguments[_key3];
  }

  var task;
  return _regenerator2.default.wrap(function takeLatestAndCancelGroupBy$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.fork)(
          /*#__PURE__*/
          _regenerator2.default.mark(function _callee3() {
            var pendingTasks, action, key, i, _task3;

            return _regenerator2.default.wrap(function _callee3$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    pendingTasks = {};

                  case 1:
                    if (!true) {
                      _context5.next = 26;
                      break;
                    }

                    _context5.next = 4;
                    return (0, _effects.take)((0, _utils.mergeActionPatterns)(pattern, cancelPattern));

                  case 4:
                    action = _context5.sent;
                    key = groupBy(action); // Cancel previous task by key

                    if (!pendingTasks[key]) {
                      _context5.next = 9;
                      break;
                    }

                    _context5.next = 9;
                    return (0, _effects.cancel)(pendingTasks[key]);

                  case 9:
                    if ((0, _utils.matchActionPattern)(action, cancelPattern)) {
                      _context5.next = 15;
                      break;
                    }

                    _context5.next = 12;
                    return _effects.fork.apply(undefined, [saga].concat(_toConsumableArray(args.concat(action))));

                  case 12:
                    pendingTasks[key] = _context5.sent;
                    _context5.next = 24;
                    break;

                  case 15:
                    if (!(key === null)) {
                      _context5.next = 24;
                      break;
                    }

                    i = 0;

                  case 17:
                    if (!(i < pendingTasks.length)) {
                      _context5.next = 24;
                      break;
                    }

                    _task3 = pendingTasks[i];
                    _context5.next = 21;
                    return (0, _effects.cancel)(_task3);

                  case 21:
                    i++;
                    _context5.next = 17;
                    break;

                  case 24:
                    _context5.next = 1;
                    break;

                  case 26:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee3, this);
          }));

        case 2:
          task = _context6.sent;
          return _context6.abrupt('return', task);

        case 4:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked3, this);
}